import React from 'react';
import { CatalogItem } from 'store/landing/types';
import { AppBundle } from 'api/optimalprint-sdk.d';
import LpShopifyCatalogItem from './LpShopifyCatalogItem';
import styles from './LpShopifyCatalog.module.scss';
import ProductCarousel from '../../../Common/ProductCarousel/ProductCarousel';
import SquareLpShopifyCatalogItem from './SquareLpShopifyCatalogItem';

interface LpShopifyCatalogItemsProps {
  items: CatalogItem[];
  title?: string;
  variant?: 'carousel' | 'grid';
}

const LpShopifyCatalog: React.FC<LpShopifyCatalogItemsProps> = ({ items, title, variant }) => {
  if (variant === 'carousel') {
    return (
      <div className={styles.carouselContainer}>
        {title && <h3 className={styles.title}>{title}</h3>}
        <ProductCarousel type="square" scrollable theme="shopify">
          {items.map((item) => (
            <SquareLpShopifyCatalogItem
              key={item.entryId}
              imageUrl={item.productImageUrl}
              imageUrlMobile={item.productImageUrlMobile}
              referenceLabel={item.title}
              referenceUrl={item.referenceUrl}
              abstractProduct={item.abstractProduct as AppBundle.Api.Entity.App.V1.IAbstractProduct}
            />
          ))}
        </ProductCarousel>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {title && <h3 className={styles.title}>{title}</h3>}

      <div className={styles.itemsContainer}>
        {items.map((item) => (
          <LpShopifyCatalogItem
            key={item.entryId}
            image={item.productImageUrl}
            title={item.title}
            imageMobile={item.productImageUrlMobile}
            referenceUrl={item.referenceUrl}
            name={item.title}
            abstractProduct={item.abstractProduct as AppBundle.Api.Entity.App.V1.IAbstractProduct}
          />
        ))}
      </div>
    </div>
  );
};

export default LpShopifyCatalog;
